














































































































import { Component, Mixins } from "vue-property-decorator";
import Search from "@/components/elements/utility/Search.vue";
import DataTable from "@/components/elements/utility/Table.vue";
import { PartialNetSuiteCustomer } from "@/models/netsuite/netsuite";
import ConfirmNewQuote from "@/components/elements/modal/ConfirmNewQuote.vue";
import { Mobile } from "@/mixins/mobile";
import { OrderMixin } from "@/mixins/orders/mixin";
import { CustomerMixin } from "@/mixins/customers/mixin";

@Component({
  components: {
    Search,
    DataTable,
    ConfirmNewQuote
  }
})
export default class CustomerList extends Mixins(
  Mobile,
  OrderMixin,
  CustomerMixin
) {
  protected fields = ["company_name", "default_billing_address"];
  protected loader: any = null;

  async created(): Promise<void> {
    this.loader = this.$loading.show(
      { opacity: 1 },
      {
        before: this.$createElement("h1", "Obtaining Customer List")
      }
    );
    await this.getCustomers();
    setTimeout(() => this.loader.hide(), 300);
  }

  protected toggleNewQuoteModal(customer: PartialNetSuiteCustomer): void {
    this.setSelectedCustomer(
      customer.customer_id.toString(),
      customer.company_name,
      1 + (customer.price_level_discount ?? 0),
      customer.customer_id,
      customer.payment_terms_id || undefined,
      customer.price_level_id,
      customer.price_level_discount ?? undefined
    );
    if (this.items.length > 0) {
      this.showModal = true;
    } else {
      this.assignAndRedirect();
    }
  }

  protected async clearOrderAndRedirect(): Promise<void> {
    this.showModal = false;
    await this.resetOrder();
    const baseLevel = this.storePriceLevels.find(l => l.id === 1) ?? null;
    await this.addMultiplier(baseLevel);
    await this.assignAndRedirect();
  }

  protected async assignAndRedirect(): Promise<void> {
    await this.reassignQuote(
      this.selected?.customer_id!,
      this.selected?.customer_name!,
      this.selected?.multiplier!,
      this.selected?.customer_netsuite_id,
      this.selected?.customer_netsuite_payment_terms_id,
      this.selected?.customer_netsuite_price_level_id,
      this.selected?.customer_netsuite_price_level_discount
    );
    await this.$router.push("/");
  }

  protected async refreshCustomers(): Promise<void> {
    this.loader = this.$loading.show(
      { opacity: 1 },
      {
        before: this.$createElement("h1", "Refreshing Customer List")
      }
    );
    await this.getCustomers(true);
    setTimeout(() => this.loader.hide(), 300);
  }

  // Triggered from child component, <Search />
  protected submitSearch(searchTerm: string): void {
    this.searchTerm = searchTerm;
  }

  protected formatHeaders(header: string): string {
    let formatted = "";
    switch (header) {
      case "company_name":
        formatted = "Customer";
        break;
      case "default_billing_address":
        formatted = "Billing Address";
        break;
      default:
        formatted = this.makeTitleCase(header);
        break;
    }
    return formatted;
  }

  protected sendToQuotesPage(customer: PartialNetSuiteCustomer): void {
    this.$router.push(`/customers/orders/${customer.customer_id}`);
  }
}
